export const PUBLIC_CARDS = '/cmn-assets/data/publicCards.json'
